const toRad = (deg) => (deg * Math.PI) / 180;

const clampNumber = (value) => (Number.isFinite(value) ? value : null);

export const haversineMiles = (lat1, lon1, lat2, lon2) => {
  const aLat = clampNumber(Number(lat1));
  const aLon = clampNumber(Number(lon1));
  const bLat = clampNumber(Number(lat2));
  const bLon = clampNumber(Number(lon2));
  if (aLat === null || aLon === null || bLat === null || bLon === null) {
    return null;
  }
  const R = 3958.8;
  const dLat = toRad(bLat - aLat);
  const dLon = toRad(bLon - aLon);
  const base =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(aLat)) * Math.cos(toRad(bLat)) * Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.asin(Math.sqrt(base));
  return R * c;
};

export const formatDistanceLabel = (distanceMiles) => {
  const value = Number(distanceMiles);
  if (!Number.isFinite(value)) return "";
  const rounded =
    value < 10 ? value.toFixed(1) : Math.round(value).toString();
  return `${rounded} mi away`;
};

export const addDistanceAndSort = (schools, lat, lng) => {
  if (!Array.isArray(schools) || schools.length === 0) return [];
  const baseLat = clampNumber(Number(lat));
  const baseLng = clampNumber(Number(lng));
  if (baseLat === null || baseLng === null) return [...schools];

  const withDistance = schools.map((school, index) => {
    const coords = school.coordinates ?? {};
    const schoolLat = coords.latitude ?? school.latitude ?? null;
    const schoolLng = coords.longitude ?? school.longitude ?? null;
    const distanceMiles = haversineMiles(baseLat, baseLng, schoolLat, schoolLng);
    return {
      ...school,
      distance_miles: distanceMiles,
      distance_label: distanceMiles != null ? formatDistanceLabel(distanceMiles) : "",
      __originalIndex: index,
    };
  });

  withDistance.sort((a, b) => {
    const aDist = a.distance_miles ?? Infinity;
    const bDist = b.distance_miles ?? Infinity;
    if (aDist === bDist) {
      return (a.__originalIndex ?? 0) - (b.__originalIndex ?? 0);
    }
    return aDist - bDist;
  });

  return withDistance.map((school, index) => {
    const { __originalIndex, ...rest } = school;
    if (index === 0) {
      return { ...rest, nearest_to_search: true };
    }
    return rest;
  });
};

export const sortStemByDistance = (stemSchools, lat, lng) =>
  addDistanceAndSort(stemSchools, lat, lng);
